/**
 * @generated SignedSource<<31c7949ba6ed3905c4282e76abb0d00a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type reactionsRemoveReactionMutation$variables = {
  blockKey: string;
  emojiName: string;
  noteId: string;
};
export type reactionsRemoveReactionMutation$data = {
  readonly NoteBlock_RemoveReaction: {
    readonly deletedId: string | null;
    readonly user: {
      readonly firstName: string;
      readonly id: string;
    };
  } | null;
};
export type reactionsRemoveReactionMutation = {
  response: reactionsRemoveReactionMutation$data;
  variables: reactionsRemoveReactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emojiName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "blockKey",
        "variableName": "blockKey"
      },
      {
        "kind": "Variable",
        "name": "emojiName",
        "variableName": "emojiName"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "RemoveBlockReaction",
    "kind": "LinkedField",
    "name": "NoteBlock_RemoveReaction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "reactionsRemoveReactionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "reactionsRemoveReactionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "8cbf36c9fa19ab619187706e5fe03d14",
    "id": null,
    "metadata": {},
    "name": "reactionsRemoveReactionMutation",
    "operationKind": "mutation",
    "text": "mutation reactionsRemoveReactionMutation(\n  $noteId: ID!\n  $blockKey: String!\n  $emojiName: String!\n) {\n  NoteBlock_RemoveReaction(noteId: $noteId, blockKey: $blockKey, emojiName: $emojiName) {\n    deletedId\n    user {\n      id\n      firstName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d84697dee671d16926ca928edb0f3df";

export default node;
